import Vue from 'vue'
import Router from 'vue-router'


// V2.0
const V2HomePage = () =>
    import ('@/pages/dappv2/homePage/HomePage')
const V2MiningHome = () =>
    import ('@/pages/dappv2/mining/MiningHome')
const DmcPoolDetail = () =>
    import ('@/pages/dappv2/mining/DmcPoolDetail')
const PoolDetail = () =>
    import ('@/pages/dappv2/mining/PoolDetail')
const lockDetail = () =>
    import ('@/pages/dappv2/mining/lockDetail')
const Invite = () =>
    import ('@/pages/dappv2/invite/Invite')
const Erc20 = () =>
    import ('@/pages/erc20/Erc20')
const Erc721 = () =>
    import ('@/pages/erc20/Erc721')
const sign = () =>
    import ('@/pages/dappv2/vipLock/sign')
const signLaunchProposal = () =>
    import ('@/pages/dappv2/vipLock/signLaunchProposal')

const VipLockHome = () =>
    import ('@/pages/dappv2/vipLock/VipLockHome')

const Mall = () =>
    import ('@/pages/dappv2/mall/MallIndex')
const MallDetail = () =>
    import ('@/pages/dappv2/mall/MallDetail')
const MallDetailBtc = () =>
    import ('@/pages/dappv2/mall/MallDetailBtc')
const MyNft = () =>
    import ('@/pages/dappv2/mynft/myNft')
const V2NftDetail = () =>
    import ('@/pages/dappv2/mynft/NftDetail')
const V2NftDetailBenefitList = () =>
    import ('@/pages/dappv2/mynft/DetailBenefit')
const V2BtcNftDetail = () =>
    import ('@/pages/dappv2/mynft/BtcNftDetail')

const V2YesterdayBenefit = () =>
    import ('@/pages/dappv2/mynft/YesterdayBenefit')
const exchange = () =>
    import ('@/pages/dappv2/swap/exchange')
const exchangeRecord = () =>
    import ('@/pages/dappv2/swap/exchangeRecord')
const NFTManage = () =>
    import ('@/pages/dappv2/mynft/nftManage')
const NFTTradeIndex = () =>
    import ('@/pages/dappv2/nftTrade/tradeIndex')
const DmcDestruction = () =>
    import ('@/pages/dappv2/others/destruction')
const daoPage = () =>
    import ('@/pages/dappv2/others/daoPage')
const lockRecord = () =>
    import ('@/pages/dappv2/vipLock/lockRecord')
const NftMigrate = () =>
    import ('@/pages/dappv2/mynft/NftMigrate')


Vue.use(Router)


const router = new Router({
    base: '/base/',
    routes: [{
            path: '/',
            name: 'V2HomePage',
            // component: DmcPledge
            component: V2HomePage
        },
        {
            path: '/Invite',
            name: 'Invite',
            component: Invite
        },
        {
            path: '/Invite/:InviteCode',
            name: 'Invite',
            component: Invite
        },
        {
            path: '/home',
            name: 'V2HomePage',
            // component: DmcPledge
            component: V2HomePage
        },
        {
            path: '/mining',
            name: 'V2MiningHome',
            // component: DmcPledge
            component: V2MiningHome
        },
        {
            path: '/mining/:active',
            name: 'V2MiningHome',
            // component: DmcPledge
            component: V2MiningHome
        },
        {
            path: '/poolDetail',
            name: 'PoolDetail',
            component: PoolDetail
        },
        {
            path: '/DmcPoolDetail',
            name: 'DmcPoolDetail',
            component: DmcPoolDetail
        },
        {
            path: '/lockDetail/:pid/:contractAddress',
            name: 'lockDetail',
            component: lockDetail
        },
        {
            path: '/Erc20',
            name: 'Erc20',
            component: Erc20
        },
        {
            path: '/Erc721',
            name: 'Erc721',
            component: Erc721
        },
        {
            path: '/sign',
            name: 'sign',
            component: sign
        },
        {
            path: '/sign/:active',
            name: 'sign',
            component: sign
        },
        {
            path: '/signLaunchProposal',
            name: 'signLaunchProposal',
            component: signLaunchProposal
        },
        {
            path: '/Mall',
            name: 'Mall',
            component: Mall
        },
        {
            path: '/Mall/:isFil',
            name: 'Mall',
            component: Mall
        },
        {
            path: '/MallDetail',
            name: 'MallDetail',
            component: MallDetail
        },
        {
            path: '/MallDetailBtc',
            name: 'MallDetailBtc',
            component: MallDetailBtc
        },
        {
            path: '/webnft',
            name: 'MyNft',
            component: MyNft
        },
        {
            path: '/webnft/:pid/:active',
            name: 'MyNft',
            component: MyNft
        },
        {
            path: '/NftDetail/:ntokenid/:contractAddress',
            name: 'V2NftDetail',
            component: V2NftDetail
        },
        {
            path: '/NftDetail/:ntokenid/:contractAddress/:isbuy',
            name: 'V2NftDetail',
            component: V2NftDetail
        },
        {
            path: '/BtcNftDetail/:ntokenid/:contractAddress',
            name: 'V2BtcNftDetail',
            component: V2BtcNftDetail
        },
        {
            path: '/BtcNftDetail/:ntokenid/:contractAddress/:isbuy',
            name: 'V2BtcNftDetail',
            component: V2BtcNftDetail
        },
        {
            path: '/NftDetailBenefitList/:ntokenid/:contractAddress/:benefitContractAddress',
            name: 'V2NftDetailBenefitList',
            component: V2NftDetailBenefitList
        },
        {
            path: '/addressNftDailyRecord/:benefitContractAddress',
            name: 'V2YesterdayBenefit',
            component: V2YesterdayBenefit
        },
        // {
        //     path: '/exchange',
        //     name: 'exchange',
        //     component: exchange
        // },
        {
            path: '/exchangeRecord/:tokenadd',
            name: 'exchangeRecord',
            component: exchangeRecord
        },
        {
            path: '/exchangeRecord',
            name: 'exchangeRecord',
            component: exchangeRecord
        },
        {
            path: '/nftManage/:benefitContractAddress',
            name: 'nftManage',
            component: NFTManage
        },
        {
            path: '/nftTradeIndex',
            name: 'nftTradeIndex',
            component: NFTTradeIndex
        },
        {
            path: '/destruction',
            name: 'DmcDestruction',
            component: DmcDestruction
        },
        {
            path: '/daoPage',
            name: 'daoPage',
            component: daoPage
        },
        {
            path: '/boardroom',
            name: 'VipLockHome',
            // component: DmcPledge
            component: VipLockHome
        },
        {
            path: '/boardroom/:active',
            name: 'VipLockHome',
            // component: DmcPledge
            component: VipLockHome
        },
        {
            path: '/lockRecord/:contractAddress/:pid',
            name: 'lockRecord',
            component: lockRecord
        },
        {
            path: '/nftMigrate',
            name: 'NftMigrate',
            // component: DmcPledge
            component: NftMigrate
        },
    ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {})
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js